import React from "react";
import "./subtitleItem.less";

const SubtitleItem = ({ value, title, showTitle, column }) => {
   let correctValue = value;
   if (column && column[0]?.precision !== ("" && undefined)) {
      correctValue = Number(correctValue).toFixed(Number(column[0]?.precision));
   }
   if (title === "-" || title === null || title === "") return null;
   return (
      <div className="gx-product-body-subtitle">
         <p className="p2 avdertisement-item-body__title">
            {showTitle === true && <b>{title}: </b>}
            {correctValue}
         </p>
      </div>
   );
};

export default SubtitleItem;
